export const getLocalStorage = (key: string) => {
  return localStorage.getItem(key);
};

export const getSessionStorage = (key: string) => {
  return sessionStorage.getItem(key);
};
